define([
	"dojo/_base/declare",
	"Apparel/StructureItemTable"
], function(declare, StructureItemTable) {

	return declare(StructureItemTable, {
		TypeRelations: {
			"Season": "IssueSeason",
			"Category1": "IssueCategory1",
			"Category2": "IssueCategory2",
			"Collection": "IssueCollection"
		}
	});
});